import PageLayout from "../../components/common/page-layout";
import Statistics from "../../components/doc-scanning/stats/statistics";
import { RequireAuth } from "../../hooks/use-auth";

/** Document ingestion volume statistics, by company, contact, user, and schema. */
const StatisticsPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        maxWidth={false}
        subtitle="Ingestion volume across both pipelines"
        title="Scan statistics"
      >
        <Statistics />
      </PageLayout>
    </RequireAuth>
  );
};

export default StatisticsPage;
